import { restApiRP } from "@plannel/services/utils/rest-api";
import ResponseUtil from "@plannel/pages/utils/response-util";

const user = JSON.parse(localStorage.getItem("user"));
const getAll = params => {
  return restApiRP.post("/api/rp-plan-actual", params);
};

const getAllForCSV = params => {
  return restApiRP.post("/api/rp-plan-actual/csv", params);
};

const getAllForRawCSV = params => {
  return fetch("/api/rp-plan-actual/raw-csv", {
    body: ResponseUtil.getExportParamsForPost(params),
    method: "POST",
    headers: {
      "Content-type": "application/json",
      "x-tenant-id": user.tenantId,
      Authorization: `${user.type} ${user.accessToken}`,
      "x-module-name": "RP"
    }
  });
};

const rpPlanVsActualService = {
  getAll,
  getAllForCSV,
  getAllForRawCSV
};

export default rpPlanVsActualService;